import React from 'react';
import { XCircle, CheckCircle } from 'lucide-react';
export function BeforeAfter() {
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-8 max-w-4xl mx-auto rounded-2xl overflow-hidden shadow-2xl" data-id="element-2">
      {/* Before - Red */}
      <div className="bg-red-50 p-8 md:p-10 border-b-4 md:border-b-0 md:border-r-4 border-red-200" data-id="element-3">
        <div className="flex items-center gap-3 mb-6" data-id="element-4">
          <XCircle className="w-8 h-8 text-red-600" data-id="element-5" />
          <h3 className="text-2xl font-bold text-red-800" data-id="element-6">Antes</h3>
        </div>
        <ul className="space-y-4" data-id="element-7">
          {['Panes secos', 'Dulces que se rompen', 'Miedo a vender', 'Cocina desordenada', 'Frustración constante'].map((item, i) => <li key={i} className="flex items-start gap-3 text-red-900/80 font-medium" data-id="element-8">
              <span className="text-red-500 mt-1" data-id="element-9">❌</span>
              {item}
            </li>)}
        </ul>
      </div>

      {/* After - Green */}
      <div className="bg-green-50 p-8 md:p-10" data-id="element-10">
        <div className="flex items-center gap-3 mb-6" data-id="element-11">
          <CheckCircle className="w-8 h-8 text-green-600" data-id="element-12" />
          <h3 className="text-2xl font-bold text-green-800" data-id="element-13">Después</h3>
        </div>
        <ul className="space-y-4" data-id="element-14">
          {['Panes suaves que no se quiebran', 'Budines húmedos y estables', 'Seguridad para ofrecer tus productos', 'Cocina organizada', 'Confianza real'].map((item, i) => <li key={i} className="flex items-start gap-3 text-green-900/80 font-bold" data-id="element-15">
              <span className="text-green-500 mt-1" data-id="element-16">✅</span>
              {item}
            </li>)}
        </ul>
      </div>
    </div>;
}